import React, { FC, useRef } from 'react'
import AddToCollectionIcon from 'svg/add-to-collection.svg'
import AddToCollectionFilledIcon from 'svg/add-to-collection-filled.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'
import CreateCollectionsModal, {
  CreateCollectionsModalApi,
} from 'apps/saatchi/collection/layouts/Modal'
import AddToCollectionComponent, {
  AddToCollectionApi,
} from 'components/Artworks/Actions/AddToCollection'

type AddToCollectionProps = {
  artworkId: number
  isAddedToCollection?: boolean
  shouldOpenCentered?: boolean
}

const AddToCollection: FC<AddToCollectionProps> = ({
  artworkId,
  isAddedToCollection,
  shouldOpenCentered,
}) => {
  const createCollectionsModalRef = useRef<CreateCollectionsModalApi>(null)
  const addToCollectionRef = useRef<AddToCollectionApi>(null)

  const handleOpenCreateCollectionsModal = () => {
    createCollectionsModalRef.current?.handleOpenModal()
  }

  const handleCreateCollectionOnSuccess = (payload) => {
    addToCollectionRef.current?.handleCreateCollectionCallback(payload)
  }

  return (
    <button
      className={styles.iconButtonDefaultStyle}
      data-action='collection'
      data-type='action'
      title='Add to Collection'
      rel='nofollow'
    >
      <AddToCollectionComponent
        artworkId={artworkId}
        handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
        ref={addToCollectionRef}
        tooltipPosition='left'
        shouldOpenCentered={shouldOpenCentered}
        //Position tooltip in the middle of the screen for mobile
        customAnimationStyle={
          shouldOpenCentered
            ? {
                position: 'fixed',
                top: '30%',
                left: '50%',
                right: 'unset',
                transform: 'translateX(-50%)',
              }
            : {}
        }
      >
        <div className={styles.iconActionContainer}>
          <AddToCollectionFilledIcon
            className={classNames(styles.iconActionAddToCollection, {
              [styles.iconActionContainerInvisible]: !isAddedToCollection,
            })}
          />
          {!isAddedToCollection && (
            <AddToCollectionIcon className={styles.iconActionAddToCollection} />
          )}
        </div>
      </AddToCollectionComponent>
      <CreateCollectionsModal
        ref={createCollectionsModalRef}
        onSuccess={handleCreateCollectionOnSuccess}
      />
    </button>
  )
}

export default AddToCollection
